import styles from "../PlanCard.module.css";
import Price from "./Price.js";
import {
  SUBSCRIPTION_PLAN_BUSINESS,
  SUBSCRIPTION_PLAN_PREMIUM,
  SUBSCRIPTION_PLAN_STARTER
} from "../../../../../../../../constants/subscriptionPlans.js";
import InfoBadge from "./InfoBadge.js";
import { ANNUAL, EVERY_30_DAYS } from "../../../../../../../../constants/subscriptionInterval.js";

const isPaidYearlyPlans = [SUBSCRIPTION_PLAN_STARTER, SUBSCRIPTION_PLAN_PREMIUM, SUBSCRIPTION_PLAN_BUSINESS];

const PriceSection = ({ plan, shopifyAppSubscriptionInterval, subscriptionInterval }) => {

  const crossedPrice = plan.crossedPrice ? `$ ${plan.crossedPrice}` : "";

  const isMonthlyPriceActive = subscriptionInterval === EVERY_30_DAYS;

  return (
    <div className={styles["priceSectionWrapper"]}>
      <div className={styles.crossedPriceWrapper}>
        {crossedPrice}
      </div>
      <div className={styles.priceWrapper}>
        <Price
          plan={plan}
          subscriptionInterval={subscriptionInterval}
        />
      </div>
      {plan.name === SUBSCRIPTION_PLAN_STARTER && isMonthlyPriceActive && <InfoBadge text="SAVE 30%" />}
      {plan.name === SUBSCRIPTION_PLAN_STARTER && !isMonthlyPriceActive && <InfoBadge text="SAVE 40%" />}
      {plan.name === SUBSCRIPTION_PLAN_PREMIUM && isMonthlyPriceActive && <InfoBadge text="SAVE 40%" />}
      {plan.name === SUBSCRIPTION_PLAN_PREMIUM && !isMonthlyPriceActive && <InfoBadge text="SAVE 50%" />}
      {plan.name === SUBSCRIPTION_PLAN_BUSINESS && isMonthlyPriceActive && <InfoBadge text="SAVE 60%" />}
      {plan.name === SUBSCRIPTION_PLAN_BUSINESS && !isMonthlyPriceActive && <InfoBadge text="SAVE 70%" />}
      {(
        (isPaidYearlyPlans.includes(plan.name) && !isMonthlyPriceActive) ||
        (plan.isCustom && shopifyAppSubscriptionInterval === ANNUAL)
      ) && <InfoBadge text="Paid Yearly" />}
    </div>
  );
};

export default PriceSection;